export const DEFAULT_GUIDE_EMBED_URL =
  'https://www.onoranzefunebricloud.com/aiuto/embed';

export const GUIDE_EMBED_URL =
  process.env.GUIDE_EMBED_URL || DEFAULT_GUIDE_EMBED_URL;

export const GUIDE_EMBED_ALLOWED_ORIGINS = [
  'https://www.onoranzefunebricloud.com',
  'https://onoranzefunebricloud.com',
];

/** Origin canonico dell'embed, usato come targetOrigin per l'identificazione. */
export const GUIDE_EMBED_ORIGIN = 'https://www.onoranzefunebricloud.com';

/** Le pagine `/aiuto/**` marcano i propri messaggi con questo `source`. */
export const GUIDE_EMBED_SOURCE = 'help_embed';
export const NOVITA_EMBED_SOURCE = 'novita_embed';
export const GUIDE_READY_SOURCES = [GUIDE_EMBED_SOURCE, NOVITA_EMBED_SOURCE];

export const GUIDE_EMBED_CHAT_MESSAGE_TYPE = 'ofc:open_chat';
export const GUIDE_EMBED_OPEN_URL_MESSAGE_TYPE = 'ofc:open_url';
export const GUIDE_EMBED_GO_BACK_MESSAGE_TYPE = 'ofc:go_back';
export const GUIDE_EMBED_READY_MESSAGE_TYPE = 'ofc:help_ready';
export const GUIDE_EMBED_IDENTIFY_MESSAGE_TYPE = 'ofc:help_identify';
export const GUIDE_EMBED_IDENTIFY_CLEAR_MESSAGE_TYPE =
  'ofc:help_identify_clear';

/**
 * Solo i tipi che il pannello sa gestire. `ofc:novita_viewed` e
 * `ofc:novita_mark_all_read` restano volutamente fuori: il Centro Aiuto non ha
 * stato letto/non letto, e' consultazione on-demand.
 */
export const GUIDE_EMBED_MESSAGE_TYPES = [
  GUIDE_EMBED_CHAT_MESSAGE_TYPE,
  GUIDE_EMBED_OPEN_URL_MESSAGE_TYPE,
  GUIDE_EMBED_GO_BACK_MESSAGE_TYPE,
];

export const GUIDE_SURFACE_PRIVATE_NAVBAR = 'giotto_private_navbar';
export const GUIDE_SURFACE_CANVAS_NAVBAR = 'giotto_canvas_navbar';

export const GUIDE_TRACK_EVENT_NAMES = {
  opened: 'aiuto_embed_opened',
  loaded: 'aiuto_embed_loaded',
  closed: 'aiuto_embed_closed',
  chat_opened: 'aiuto_embed_chat_opened',
  article_opened: 'aiuto_embed_article_opened',
};

/** La larghezza scelta e' una preferenza dell'utente, non stato di sessione. */
export const GUIDE_WIDTH_STORAGE_KEY = 'giotto.guide_panel.expanded';
